import { Grid, List, ListItem, Typography } from '@mui/material'
import {
    RedeemButton,
    textFontStyle,
} from '../CalculationInput/CalculatePanelUI'
import { useFormat } from 'Services/localize/format'
import { t } from 'i18next'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import CreditCardPanelMobile from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/CreditCard/CreditCardPanelMobile'

function CreditCardPanel({
    tenderedAmount,
    useRedeemPointButton,
    disabledRedeemPoint,
    isRedeemPointMode,
    onClickRedeemPoint,
}: {
    tenderedAmount: number
    useRedeemPointButton?: boolean
    disabledRedeemPoint?: boolean
    isRedeemPointMode?: boolean
    onClickRedeemPoint?: (selected: boolean) => void
}) {
    const { currency } = useFormat()
    const { isMobile } = useScreenSize()

    if (isMobile)
        return <CreditCardPanelMobile tenderedAmount={tenderedAmount} />
    return (
        <Grid
            item
            sx={{
                backgroundColor: 'background.default',
                height: '100%',
            }}
            container
            direction="column"
            m={0}
            p={2}
        >
            <Grid item>
                <Typography color="primary" sx={textFontStyle} align="left">
                    Charge Amount:
                </Typography>
            </Grid>
            <Grid item my={2}>
                <List>
                    <ListItem>
                        <Grid item container justifyContent="end">
                            <Grid item>
                                <Typography variant="subtitle1">
                                    {`${currency(tenderedAmount)}`}
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItem>
                </List>
            </Grid>
            {useRedeemPointButton && (
                <Grid>
                    <RedeemButton
                        sx={{
                            backgroundColor: isRedeemPointMode
                                ? 'secondary.main'
                                : 'default.dark',
                            color: isRedeemPointMode
                                ? 'white'
                                : 'default.contrastText',
                        }}
                        onClick={() => {
                            onClickRedeemPoint?.(!isRedeemPointMode)
                        }}
                        disabled={disabledRedeemPoint}
                    >
                        {isRedeemPointMode
                            ? 'Back to payment'
                            : t('finish.button.redeem_points')}
                    </RedeemButton>
                </Grid>
            )}
        </Grid>
    )
}
export default CreditCardPanel
